import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CxcmaegaranteService {
  public way: string;

  constructor(private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    private confIniciales: ConfInicialesService,
    private usuario:Usuario ) {
    this.way = sessionStorage.getItem('way');
  }
  busPAISRESI(): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/nom/empleados/iq6dfp0yy2ql553', {
      elementos: {},
    }, this.confIniciales.httpOptions());
  }
  erNombreSexo(CLI_SEXO) {
    return this.http.post(this.way + '/ventas/cliente/1dbbe2cbdbb8e', {
      elementos: {
        CLI_SEXO
      },
    }, this.confIniciales.httpOptions());
  }
  erNombreEstadoCivil(CLI_ESTCIV) {
    return this.http.post(this.way + '/ventas/cliente/3b77c597b73b9e0000000000', {
      elementos: {
        CLI_ESTCIV
      },
    }, this.confIniciales.httpOptions());
  }
  insertargarante(item) {
    return this.http.post<any[]>(this.way + '/cxc/cxcmaegarante/4afc76faadc15c00000', {
      elementos: {
        p_GAR_ID :item.GAR_ID,
        p_COM_CODIGO :'01',
        p_GAR_NOMBRE  :item.GAR_NOMBRE,
        p_GAR_NACIONALIDAD :item.GAR_NACIONALIDAD,
        p_GAR_FECNAC  :item.GAR_FECNAC,
        p_GAR_SEXO :item.GAR_SEXO,
        p_GAR_EDAD :item.GAR_EDAD,
        p_GAR_ESTCIVIL :item.GAR_ESTCIVIL,
        p_GAR_DIRECCION  :item.GAR_DIRECCION,
        p_GAR_TELEFONO1  :item.GAR_TELEFONO1,
        p_GAR_TELEFONO2  :item.GAR_TELEFONO2,
        p_GAR_CORREO  :item.GAR_CORREO,
        p_GAR_SITLAB   :item.GAR_SITLAB,
        p_GAR_INGMEN  :item.GAR_INGMEN,
        p_GAR_BIEINM :item.GAR_BIEINM,
        p_GAR_BIEINMDES   :item.GAR_BIEINMDES,
        p_GAR_VEHICULO :item.GAR_VEHICULO,
        p_GAR_VEHDES   :item.GAR_VEHDES,
        p_GAR_IDCONYUGE   :item.GAR_IDCONYUGE,
        p_GAR_NOMCONY :item.GAR_NOMCONY,
        p_GAR_DIRCONY :item.GAR_DIRCONY,
        p_GAR_TELCONY :item.GAR_TELCONY,
        p_GAR_CORCONY  :item.GAR_CORCONY,
        p_GAR_EMPTRA  :item.GAR_EMPTRA,
        p_GAR_DIREMPTRA :item.GAR_DIREMPTRA,
        p_GAR_TELEMPTRA  :item.GAR_TELEMPTRA,
        p_GAR_COREMOTRA :item.GAR_COREMOTRA,
        p_USU_IDENTIFICACION :this.usuario.identificacion,
        p_GAR_TIPOID :item.GAR_TIPOID,
        p_GAR_VALIDACION:item.GAR_VALIDACION,
        p_GAR_NUEVO :item.GAR_NUEVO
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getgarante(codigo) {
    return this.http.post<any []>(this.way + '/cxc/cxcmaegarante/662fcf57aadc14000000', {
      elementos: {
        p_GAR_ID :codigo,
        p_COM_CODIGO:'01',
        p_tipo:'C'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  seleccionarRegistroProm(tipo,codigo) {
    return this.http.post<any []>(this.way + '/cxc/cxcmaegarante/38eab98c962eae000000000', {
      elementos: {
        p_GAR_ID :codigo,
        p_COM_CODIGO:'01',
        p_tipo:tipo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  busSitLab(): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxcmaegarante/1077792ed54bc7000', {
      elementos: {},
    }, this.confIniciales.httpOptions());
  }
  verificargarante(codigo) {
    return this.http.post<any []>(this.way + '/cxc/cxcmaegarante/1f76e4f93150570000000000000', {
      elementos: {
        p_GAR_ID :codigo,
        p_COM_CODIGO:'01',
        
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  borrarRegistro(codigo) {
    return this.http.post<any []>(this.way + '/cxc/cxcmaegarante/3ab2b4aeadc15c00000', {
      elementos: {
        p_GAR_ID :codigo,
        p_COM_CODIGO:'01',
        
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
